// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsRemediation = {
  summaryRemediation: "待整改项：{count}",
  summaryRemediationCritical: "严重整改项：{count}",
  remediationPriorities: {
    warning: "预警",
    critical: "严重",
  },
  remediationCategories: {
    object_space: "对象空间",
    reference: "引用治理",
  },
  remediationActions: {
    enable_space_governance: "将对象空间纳入治理",
    reactivate_object_space: "恢复对象空间为可用状态",
    review_readonly_space_policy: "复核只读对象空间策略",
    configure_space_grants: "补齐对象空间授权",
    resolve_blocked_delete_assets: "处理删除受阻资产",
    normalize_reference_scope: "规范引用作用域",
    review_high_binding_references: "复核高绑定引用",
    repair_reference_bindings: "修复无资产引用绑定",
    normalize_reference_service: "规范服务命名",
  },
  remediationReasons: {
    space_unmanaged: "对象空间未纳入治理",
    space_disabled: "对象空间已停用",
    space_readonly: "对象空间为只读状态",
    space_no_grants: "对象空间未配置授权",
    space_has_delete_blocked_assets: "空间内存在删除受阻资产",
    non_global_scope: "引用作用域未标准化",
    high_binding_count: "引用绑定数过高",
    binding_without_assets: "存在无资产的引用绑定",
    service_not_normalized: "服务标识未标准化",
  },
} as const;
